export const FETCH_LEAVES = "FETCH_LEAVES";
export const FETCH_LEAVES_SUCCESS = "FETCH_LEAVES_SUCCESS";
export const FETCH_LEAVES_FAILURE = "FETCH_LEAVES_FAILURE";

export const CREATE_LEAVE = "CREATE_LEAVE";
export const CREATE_LEAVE_SUCCESS = "CREATE_LEAVE_SUCCESS";
export const CREATE_LEAVE_FAILURE = "CREATE_LEAVE_FAILURE";

export const UPDATE_LEAVE = "UPDATE_LEAVE";
export const UPDATE_LEAVE_SUCCESS = "UPDATE_LEAVE_SUCCESS";
export const UPDATE_LEAVE_FAILURE = "UPDATE_LEAVE_FAILURE";

export const DELETE_LEAVE = "DELETE_LEAVE";
export const DELETE_LEAVE_SUCCESS = "DELETE_LEAVE_SUCCESS";
export const DELETE_LEAVE_FAILURE = "DELETE_LEAVE_FAILURE";